import React from 'react';
import { OTPDataItemTableType, OTPFormType } from 'entities/sendOTP/types';
import { useUpdateDefaultValues } from 'entities/sendOTP/lib/hooks';
import { Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from 'entities/sendOTP/model';
import { OtpCard } from 'entities/sendOTP/ui/OTPCard';
import { useUpdateOTPByIdMutation } from 'entities/sendOTP/api';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useDispatch } from 'react-redux';

type UpdateOTPCardPropsType = {
  data: OTPDataItemTableType | null;
};
export const UpdateOtpCard = ({ data }: UpdateOTPCardPropsType) => {
  const dispatch = useDispatch();
  const [updateOTP] = useUpdateOTPByIdMutation();

  const defaultValues = useUpdateDefaultValues(data);

  const updateOTPForm = useForm<OTPFormType>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as Resolver<OTPFormType>,
    defaultValues,
  });

  const onSubmit: SubmitHandler<OTPFormType> = (dataForm) => {
    updateOTP({ id: data?.id, data: dataForm }).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  return (
    <OtpCard
      form={updateOTPForm}
      onSubmit={onSubmit}
      textButton="Изменить"
    />
  );
};
